"use client";

import { cn } from "@watt/ui/utils/classname-tailwind-merge";
import type { ReactNode } from "react";

export interface VerificationActionsProps {
  children: ReactNode;
  className?: string;
  asChild?: boolean;
}

export function VerificationActions({
  children,
  className,
  asChild = false
}: VerificationActionsProps) {
  if (asChild) {
    return <>{children}</>;
  }

  return (
    <div className={cn("flex items-center gap-2", className)}>{children}</div>
  );
}
